<div class="detail-fee-wrapper" [class.modal]="pageType === 'modal'">
  <div class="info" *ngIf="pageType === 'sidebar'">
    <div class="top">
      <nz-table
        #nzTable
        class="host-overlap-table"
        [nzData]="list"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
      >
        <thead>
          <tr>
            <th [nzWidth]="'100px'">{{ "word.type" | translate }}</th>
            <th>{{ "word.item" | translate }}</th>
            <th>{{ "word.amount" | translate }}</th>
            <th>{{ "word.payment_method" | translate }}</th>
            <th [nzWidth]="'80px'">{{ "order.trade_time" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of nzTable.data">
            <td>{{ getTypeName(data?.type) }}</td>
            <td>
              <div *ngIf="data?.type === 1" [attr.title]="getInOptionName(data?.action_type)">
                {{ getInOptionName(data?.action_type) }}
              </div>
              <div *ngIf="data?.type === -1" [attr.title]="getOutOptionName(data?.action_type)">
                {{ getOutOptionName(data?.action_type) }}
              </div>
            </td>
            <td>{{ data?.currency }}&nbsp;{{ data?.amount }}</td>
            <td>
              <div class="credentials">
                <span class="type" *ngIf="data?.type === 1">{{ getInTradeName(data?.payment_method) }}</span>
                <span class="type" *ngIf="data?.type === -1">{{ getOutTradeName(data?.payment_method) }}</span>
                <div class="pics" (click)="viewVoucher(data?.invoice)" *ngIf="data?.invoice?.length > 0">
                  <img src="/assets/icon/attachment.png" />
                  <span class="number">{{ data?.invoice?.length }}</span>
                </div>
              </div>
            </td>
            <td>{{ data?.action_time | dateformat }}</td>
          </tr>
        </tbody>
      </nz-table>
    </div>
    <div class="detail">
      <a (click)="showCompleteTable()">{{ "word.view_details" | translate }} ></a>
    </div>
  </div>
  <div *ngIf="pageType !== 'sidebar'">
    <host-finance-complete-table
      [code]="code"
      [list]="list"
      [currency]="currency"
      (refreshModal)="needRefresh($event)"
    ></host-finance-complete-table>
  </div>
  <div class="footer border-t border-solid border-c-gs">
    <div class="button">
      <button class="mr-3" nz-button nzType="primary" nzSize="large" (click)="recordFinance()">
        {{ "word.add_note" | translate }}
      </button>
      <button nz-button nzType="default" nzSize="large" (click)="close()">
        {{ "word.close" | translate }}
      </button>
    </div>
  </div>
</div>
